const vendrediSuiteContent = `
While you are lost in your thoughts, your manager comes to explain the problem to you.
The project needs to be finished for Tuesday evening. There are about 4 days of work to catch up on.
If you were to work this weekend, we might just get it in on time. It is a very important project, you see…
`

const vendrediSuiteChoices = ['transparence', 'recup', 'ardeche']

export default [
  {
    id: 'vendredi',
    content: `
    Friday evening, 6.45pm. You're going home in 5 minutes.
    Your manager calls you: "Sorry to bother you, Jan and I need to ask something… how can I put this… ?"
    
    What is your reaction ?
    `,
    choices: ['vendredisuite1', 'vendredisuite2', 'vendredisuite3'],
  },
  {
    id: 'vendredisuite1',
    optionText: `That smells like trouble, I don't like it…`,
    content: vendrediSuiteContent,
    choices: vendrediSuiteChoices,
  },
  {
    id: 'vendredisuite2',
    optionText: `Great, I've never felt so useful !`,
    content: vendrediSuiteContent,
    choices: vendrediSuiteChoices,
  },
  {
    id: 'vendredisuite3',
    optionText: `Oh no… who's handed their project in late… ?`,
    content: vendrediSuiteContent,
    choices: vendrediSuiteChoices,
  },
  {
    id: 'transparence',
    optionText: `« I think if we rush it like that, we can't guarantee the quality of the deliverables.
    I would prefer to be up-front with the client, and offer a later delivery. In return,
    I will take responsibility for the quality,
    that way the client will come back with fewer problems and will be more satisfied with the work produced. »`,
    content: `
    Your answer is solid; you offer an alternative solution without excessive workload and
    preserve the tranquility of your weekend.
    Your superiors now have something to tell the client when they make them wait…

    *END*
    `,
  },
  {
    id: 'recup',
    optionText: `« Yes, I totally understand. Send me a brief and the documents by tomorrow morning. »`,
    content: `
    You accept the mission grudgingly, without really expressing your frustration.
    Make sure this is a rare exception, in order to maintain your work-life balance!

    *END*
    `,
  },
  {
    id: 'ardeche',
    optionText: `« That's a shame, I'm off for a weekend in the countryside…
    I’m sure we'll think of something, see you Monday ! »`,
    content: `
    We would all love to give this kind of indifferent answer, wouldn't we?
    However, a comeback like that is probably only the start of your problems.
    Even if you feel like your manager crossed a line, he did take the trouble to ask politely.
    Maybe you should have embarked on your response in a similar manner,
    with a view to trying to find a solution together.

    *END*
    `,
  },
]
